import { AuthenticatedUser_Query } from "@generated/AuthenticatedUser_Query.graphql";
import { graphql } from "babel-plugin-relay/macro";
import React, { ReactNode } from "react";
import { useLazyLoadQuery } from "react-relay";
import { CurrentUser } from "./CurrentUser.component";
import { MaintenanceScreen } from "../../../app/screens/MaintenanceScreen";
import { useTypedSelector } from "../../redux/redux-store";
import { selectAuthSlice } from "../../redux/slices/auth.slice";
import { DoccheckUnauthorizedScreen } from "../../screens/doccheck-unauthorized-screen";
import { isWissenwirktApp } from "../../utils/isWissenwirktApp";

const QUERY = graphql`
	query AuthenticatedUser_Query {
		Maintenance {
			MaintenanceUpdate {
				id
				isUpdating
			}
		}
		Viewer {
			Auth {
				currentUser {
					user {
						extension(userExtensionKind: InfectopharmUserExtension) {
							... on InfectopharmUserExtension {
								globalUserStatus
							}
						}
					}
				}
			}
		}
	}
`;
interface OwnProps {
	loginFallback: ReactNode;
	children: any;
}

export function AuthenticatedUser({ children, loginFallback }: OwnProps) {
	const authState = useTypedSelector(selectAuthSlice);

	const data = useLazyLoadQuery<AuthenticatedUser_Query>(
		QUERY,
		{},
		{ fetchPolicy: "network-only" },
	);

	const isUpdating = data.Maintenance.MaintenanceUpdate.isUpdating;
	const isDoccheckUser =
		data.Viewer.Auth.currentUser?.user.extension?.globalUserStatus == "doccheck";

	return (
		<>
			{isUpdating ? (
				<MaintenanceScreen />
			) : isDoccheckUser && !isWissenwirktApp ? (
				<DoccheckUnauthorizedScreen />
			) : authState.isLoggedIn ? (
				<CurrentUser>{children}</CurrentUser>
			) : (
				loginFallback
			)}
		</>
	);
}
